import axios from "axios";
import { getOrCreateGuestDeviceId } from "../guestIntent";
import { API_URL } from "../../config/env";
import {
  reportApiNetworkFailure,
  reportApiSuccess,
} from "./apiReachability";

const api = axios.create({
  baseURL: API_URL, // /api in production; localhost in development
  withCredentials: true, // carry/set HttpOnly cookies
});

// Reads a cookie value by name (used for the double-submit CSRF token).
const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : "";
};

const CSRF_SAFE_METHODS = new Set(["get", "head", "options"]);

// Set default Content-Type for JSON requests only (not for FormData)
api.interceptors.request.use((config) => {
  // Only set Content-Type if it's not already set and it's not FormData
  if (!config.headers["Content-Type"] && !(config.data instanceof FormData)) {
    config.headers["Content-Type"] = "application/json";
  }
  try {
    config.headers["X-Guest-Device-Id"] = getOrCreateGuestDeviceId();
  } catch {
    /* localStorage unavailable */
  }
  // Attach CSRF token for state-changing requests (double-submit cookie).
  try {
    const method = (config.method || "get").toLowerCase();
    if (!CSRF_SAFE_METHODS.has(method)) {
      const csrfToken = readCookie("csrf_token");
      if (csrfToken) {
        config.headers["X-CSRF-Token"] = csrfToken;
      }
    }
  } catch {
    /* document.cookie unavailable */
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    reportApiSuccess();
    return response;
  },
  (error) => {
    const canceled =
      error?.code === "ERR_CANCELED" ||
      error?.name === "CanceledError" ||
      error?.name === "AbortError";
    if (!canceled && !error?.response) {
      reportApiNetworkFailure();
    }
    return Promise.reject(error);
  },
);

export default api;
